import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-local-campaign-legend',
  templateUrl: './local-campaign-legend.component.html',
  styleUrls: ['./local-campaign-legend.component.scss']
})
export class LocalCampaignLegendComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
